import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'BONO 1 — Guía de Terrenos',
  subtitle: 'Cómo Elegir el Terreno Correcto Antes de Construir',
  desc: 'Los 8 puntos que hay que verificar antes de comprar. Orientación solar, pendiente y servicios — lo que nadie te cuenta.',
  value: '$8.900'
}, {
  num: '02',
  title: 'BONO 2 — Guía de Terminaciones',
  subtitle: 'Las Terminaciones que Más Valor Agregan al Menor Costo',
  desc: 'Las 10 terminaciones con mayor ROI en el mercado argentino. Qué hace que una casa "se vea cara" sin serlo.',
  value: '$9.900'
}, {
  num: '03',
  title: 'BONO 3 — El Layout Perfecto',
  subtitle: 'Distribuí los Muebles Antes de Construir la Primera Pared',
  desc: 'Los 5 principios de distribución. Medidas mínimas de cada espacio. Grilla imprimible 1:50. Checklist de 20 puntos.',
  value: '$9.900'
}, {
  num: '04',
  title: 'BONO EXTRA — 30 Casas Modernas Argentina',
  subtitle: 'Fachadas + Renders + Distribuciones: Elegí tu Estilo en 15 Minutos',
  desc: '30 diseños modernos argentinos con render fotorrealista + ilustración técnica + distribución amueblada por cada uno.',
  value: '$12.900'
}];
export function BonusSection() {
  return <section id="bonos" className="py-20 bg-white pt-[48px] pb-[48px]" data-id="element-22">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 text-gold mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-27">
            4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-28">
            SIEMPRE INCLUIDOS EN LOS DOS PACKS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-beige rounded-xl p-6 border border-beige-dark relative overflow-hidden group hover:border-gold transition-colors" data-id="element-30">
              <div className="absolute top-0 right-0 bg-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                GRATIS
              </div>
              <div className="flex items-start gap-4" data-id="element-32">
                <div className="text-4xl font-serif font-bold text-gold/30 group-hover:text-gold/50 transition-colors" data-id="element-33">
                  {bonus.num}
                </div>
                <div data-id="element-34">
                  <h3 className="font-bold text-lg text-charcoal mb-1 flex items-center gap-2" data-id="element-35">
                    🎁 {bonus.title}
                  </h3>
                  <p className="text-sm font-semibold text-gold mb-3" data-id="element-36">
                    {bonus.subtitle}
                  </p>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-37">{bonus.desc}</p>
                  <div className="flex items-center gap-2 text-sm" data-id="element-38">
                    <span className="text-gray-400 line-through" data-id="element-39">
                      {bonus.value}
                    </span>
                    <span className="font-bold text-green-600" data-id="element-40">GRATIS</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center bg-charcoal text-white py-6 rounded-xl border border-gold" data-id="element-41">
          <p className="text-lg md:text-xl font-medium" data-id="element-42">
            Valor total bonos{' '}
            <span className="line-through text-gray-400 mx-2" data-id="element-43">$41.600</span>
            <span className="text-gold font-bold" data-id="element-44">
              → GRATIS en los dos packs
            </span>
          </p>
        </div>
      </div>
    </section>;
}